import React, { useState, useRef, useEffect, useContext } from 'react'
import '../css/Home.css'
import RoomIcon from '@material-ui/icons/Room';
import MailIcon from '@material-ui/icons/Mail';
import Typewriter from 'typewriter-effect'
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import DescriptionIcon from '@material-ui/icons/Description';
import "../css/Skills.css"
import SVG3DTagCloud from '3d-word-cloud';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import { Bounce } from 'gsap/gsap-core';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import { Power2, TimelineLite } from 'gsap/all';
// import { Link } from 'react-router-dom';
import $ from 'jquery'
import About from './About';
import Portfolio from './Portfolio';
import Skills from './Skills'
import Contact from './Contact'
import Navbar from './Navbar';
import ScrollButton from './ScrollButton';
import { Helmet } from 'react-helmet';
import emailjs from '@emailjs/browser';

function Home() {
    $(window).on('load', () => {
        setTimeout(() => {
            $(".loader__wrapper").fadeOut("slow")
        }, 1300);
    })

    let currentPixel = window.pageYOffset

    const looper = function () {
        const newPixel = window.pageYOffset;
        const diff = newPixel - currentPixel
        const speed = diff * 0.04;
        if (document.getElementById("myportfolio"))
            document.getElementById("myportfolio").style.transform = "skewY(" + speed + "deg)"


        currentPixel = newPixel;

        requestAnimationFrame(looper)
    }

    useEffect(() => {
        // gsap.from('.contact__ping', { y: -200, duration: 1.2, ease: Bounce.easeOut, opacity: 0 })
        looper();
    }, [])

    const [email, setemail] = useState()
    const [name, setname] = useState()
    const [subject, setsubject] = useState()
    const [message, setmessage] = useState()
    const [readOnly, setreadOnly] = useState(false)
    const [service1, setservice1] = useState(false)
    const [service2, setservice2] = useState(false)
    const [service3, setservice3] = useState(false)

    const toastId = React.useRef(null);

    const notify = () => toastId.current = toast.info('Sending.....', {
        position: "bottom-left",
        progress: 0,
    });

    const dismiss = () => toast.dismiss(toastId.current);

    const success = () => toast.success('Sent Successfully', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const errorMail = () => toast.error('Sorry Cannot send mail', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const handleClick = (e) => {
        e.preventDefault()
        setreadOnly(true)
        axios.post("http://localhost:3001/mail", {
            email: email,
            subject: subject,
            message: message
        }).then(res => {
            if (res.status == 200) {
                setemail("")
                setmessage("")
                setsubject("")
                setreadOnly(false)
                dismiss()
                success()
            }
        }).catch(err => alert(err))
    }


    gsap.registerPlugin(ScrollTrigger);
    const ref = useRef(null);
    let sections = gsap.utils.toArray(".panel");

    useEffect(() => {
        const element = ref.current;
        gsap.fromTo(
            element.querySelector(".contact__ping"),
            {
                opacity: 0,
                // y: -20,
            },
            {
                opacity: 1,
                // y: 0,
                scrollTrigger: {
                    trigger: element.querySelector(".contact__ping"),
                    start: "top 60%",
                    end: "bottom center",
                    scrub: 0.3,
                }
            }
        )
    }, [])

    useEffect(() => {
        const element = ref.current;
        gsap.fromTo(
            element.querySelector(".service__1"),
            {
                opacity: 0,
                y: -20,
                x: -50
            },
            {
                opacity: 1,
                y: 0,
                x: 0,
                scrollTrigger: {
                    trigger: element.querySelector(".service__1"),
                    start: "top 60%",
                    end: "bottom center",
                    scrub: 0.3,
                }
            }
        )
    }, [])

    useEffect(() => {
        const element = ref.current;
        gsap.fromTo(
            element.querySelector(".service__2"),
            {
                opacity: 0,
                y: -20,
                x: 150
            },
            {
                opacity: 1,
                y: 0,
                x: 0,
                scrollTrigger: {
                    trigger: element.querySelector(".service__2"),
                    start: "top 60%",
                    end: "bottom center",
                    scrub: 0.3,
                }
            }
        )
    }, [])

    useEffect(() => {
        $(document).ready(function () {
            var entries = [
                { label: 'HTML' },
                { label: 'CSS' },
                { label: 'Javascript' },
                { label: 'ReactJS' },
                { label: 'NodeJS' },
                { label: 'ExpressJS' },
                { label: 'MongoDB' },
                { label: 'Mongoose' },
                { label: 'SQL' },
                { label: 'C' },
                { label: 'C++' },
                { label: 'Jquery' },
                { label: 'XML' },
                { label: 'Java' },
                { label: 'Deep Learning' },
                { label: 'Kotlin' },
                { label: 'Machine Learning' },
                { label: 'Python' },
                { label: 'Android Studio' },
                { label: 'REST Services' },
                { label: 'C#' },
                { label: 'GSAP' }
            ]

            var settings = {
                entries: entries,
                width: 640,
                height: 480,
                radius: "65%",
                radiusMin: 75,
                bgDraw: true,
                bgColor: "rgba(0,0,0,0)",
                opacityOver: 1.00,
                opacityOut: 0.05,
                opacitySpeed: 6,
                fov: 800,
                speed: 0.5,
                fontFamily: 'Poppins, sans-serif',
                fontSize: "30",
                fontColor: "rgb(80, 149, 158)",
                // fontWeight: "bold",
                // fontFamily: 'poppins',
                fontStyle: "normal",
                fontStretch: "normal",
                fontToUpperCase: false
            }
            SVG3DTagCloud(document.getElementById('tag'), settings)
        })
    }, [])

    useEffect(() => {
        const element = ref.current;
        gsap.fromTo(
            element.querySelector(".service__3"),
            {
                opacity: 0.5,
                y: -20,
                x: -50
            },
            {
                opacity: 1,
                scrollTrigger: {
                    trigger: element.querySelector(".service__3"),
                    start: "top 100%",
                    end: "bottom center",
                    scrub: 0.3,
                }
            }
        )
    }, [])

    useEffect(() => {
        const element = ref.current;
        gsap.fromTo(
            element.querySelector(".about__blob__image"),
            {
                opacity: 0.5,
                scale: 0.6,
                x: -2,
                y: 20
            },
            {
                opacity: 1,
                scale: 0.4,
                x: 45,
                y: 30,
                scrollTrigger: {
                    trigger: element.querySelector(".about__blob__image"),
                    start: "top 100%",
                    end: "bottom center",
                    scrub: 0.3,
                }
            }
        )
    }, [])

    useEffect(() => {
        const element = ref.current;
        gsap.fromTo(
            element.querySelector(".about__me"),
            {
                opacity: 0.5,
                y: -80,
                scale: 0.5
            },
            {
                opacity: 1,
                scale: 1,
                y: 0,
                scrollTrigger: {
                    trigger: element.querySelector(".about__me"),
                    start: "top 100%",
                    end: "bottom center",
                    scrub: 0.3,
                }
            }
        )
    }, [])

    useEffect(() => {
        const element = ref.current;
        gsap.fromTo(
            element.querySelector(".skills__title"),
            {
                opacity: 0.5,
                x: -50,
                scale: 0.5
            },
            {
                opacity: 1,
                scale: 1,
                x: 0,
                scrollTrigger: {
                    trigger: element.querySelector(".skills__title"),
                    start: "top 100%",
                    end: "bottom center",
                    scrub: 0.3,
                }
            }
        )
    }, [])



    const cursorChangeService1 = () => {
        setservice1(true)
        $(".ring").css("height", "100px");
        $(".ring").css("width", "100px");
        $(".ring").text("Open");
        $(".ring").css("text-align", "center");
        $(".ring").css("place-items", "center");
        $(".ring").css("background-color", "#fb839e");
        $(".ring").css("font-family", "'Averia Serif Libre', cursive");
        $(".ring").css("color", "#000");
        $(".ring").css("font-size", "1em");
        $(".ring").css("display", "grid");
    }

    const cursorChangeService2 = () => {
        setservice2(true)
        $(".ring").css("height", "100px");
        $(".ring").css("width", "100px");
        $(".ring").text("Open");
        $(".ring").css("text-align", "center");
        $(".ring").css("place-items", "center");
        $(".ring").css("background-color", "#fb839e");
        $(".ring").css("font-family", "'Averia Serif Libre', cursive");
        $(".ring").css("color", "#000");
        $(".ring").css("font-size", "1em");
        $(".ring").css("display", "grid");
    }

    const cursorChangeService3 = () => {
        setservice3(true)
        $(".ring").css("height", "100px");
        $(".ring").css("width", "100px");
        $(".ring").text("Open");
        $(".ring").css("text-align", "center");
        $(".ring").css("place-items", "center");
        $(".ring").css("background-color", "#fb839e");
        $(".ring").css("font-family", "'Averia Serif Libre', cursive");
        $(".ring").css("color", "#000");
        $(".ring").css("font-size", "1em");
        $(".ring").css("display", "grid");
    }

    const cursorChangeService1End = () => {
        setservice1(false)
        $(".ring").css("height", "22px");
        $(".ring").css("width", "22px");
        $(".ring").text("");
        $(".ring").css("background-color", "transparent");
        $(".cursor__bg").css("background", "none");
    }

    const cursorChangeService2End = () => {
        setservice2(false)
        $(".ring").css("height", "22px");
        $(".ring").css("width", "22px");
        $(".ring").text("");
        $(".ring").css("background-color", "transparent");
    }

    const cursorChangeService3End = () => {
        setservice3(false)
        $(".ring").css("height", "22px");
        $(".ring").css("width", "22px");
        $(".ring").text("");
        $(".ring").css("background-color", "transparent");
    }


    const [navClick, setnavClick] = useState(false)

    const cursorChange = () => {
        $(".ring").css("height", "100px");
        $(".ring").css("width", "100px");
        $(".ring").text("Let's Collaborate");
        $(".ring").css("text-align", "center");
        $(".ring").css("place-items", "center");
        $(".ring").css("background-color", "#fb839e");
        $(".ring").css("font-family", "'Tourney', cursive");
        $(".ring").css("color", "#000");
        $(".ring").css("font-size", "1em");
        $(".ring").css("display", "grid");
    }

    const cursorChangeEnd = () => {
        $(".ring").css("height", "22px");
        $(".ring").css("width", "22px");
        $(".ring").text("");
        $(".ring").css("background-color", "transparent");
    }
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalIsOpen2, setIsOpen2] = useState(false);
    const [modalIsOpen3, setIsOpen3] = useState(false);

    const params = {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
        },
        pagination: {
            el: '.swiper-pagination'
        }
    }

    const [scroll, setScroll] = useState(0);

    useEffect(() => {

        let progressBarHandler = () => {

            const totalScroll = document.documentElement.scrollTop;
            const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scroll = `${totalScroll / windowHeight}`;

            setScroll(scroll);
        }

        window.addEventListener("scroll", progressBarHandler);

        return () => window.removeEventListener("scroll", progressBarHandler);
    });

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    function closeModal() {
        setIsOpen(false);
    }

    const service1Model = () => {
        setIsOpen(true)
    }

    const service2Model = () => {
        setIsOpen2(true)
    }

    const service3Model = () => {
        setIsOpen3(true)
    }



    const sendEmail = (e) => {
        e.preventDefault();
        notify()
        setreadOnly(true)
        emailjs.sendForm('service_av55k3a', 'template_sk6p6wi', e.target, 'OuTeg_FW6f1iHV0ZB')
            .then((result) => {
                setemail("")
                setmessage("")
                setsubject("")
                setname("")
                setreadOnly(false)
                dismiss()
                success()
            }, (error) => {
                console.log(error.text);
                setreadOnly(false)
                dismiss()
                errorMail()
            });
    };

    return (
        <div ref={ref}>
            <Helmet>

                <title>Shyam Sundar - Portfolio</title>
                <meta name="description" content="Portfolio web site created by Shyam Sundar B, web and android app developer. 
A student of SASTRA Deemed to be University." />
                <meta name="google-site-verification" content="4fimjNvHrmwKiMb4b-JsAqv2ltAcEKEuQ7dYs4YCPqo" />
                <meta itemprop="name" content="Shyam Sundar - Portfolio" />
                <meta itemprop="description" content="Portfolio web site created by Shyam Sundar B, web and android app developer. 
A student of SASTRA Deemed to be University." />
                <meta itemprop="image" content="https://shyam-sundar-b.web.app/shyam-sundar-b.png" />

                <meta property="og:url" content="https://shyam-sundar-b.web.app/" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Shyam Sundar - Portfolio" />
                <meta property="og:description" content="Portfolio web site created by Shyam Sundar B, web and android app developer.
A student of SASTRA Deemed to be University." />
                <meta property="og:image" content="https://shyam-sundar-b.web.app/shyam-sundar-b.png" />


                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Shyam Sundar - Portfolio" />
                <meta name="twitter:description" content="Portfolio web site created by Shyam Sundar B, web and android app developer.
A student of SASTRA Deemed to be University." />
                <meta name="twitter:image" content="https://shyam-sundar-b.web.app/shyam-sundar-b.png" />

            </Helmet>
            {/* <div className=''> */}
            <div className='loader__wrapper'>
                <div className='loader__wrapper__name'>
                    Shyam Sundar
                    <div className='loader__dot'> . </div>
                    <div> B </div>
                </div>
                <div class="line">
                    <div class="inner"></div>
                </div>
            </div>
            {/* </div> */}
            <div id="progressBarContainer">
                <div id="progressBar" style={{ transform: `scale(${scroll}, 1)`, opacity: `${scroll}` }} />
            </div>
            <ScrollButton />
            {!navClick ?
                <div className="nav__burger" onClick={() => setnavClick(!navClick)}>
                    <p>Menu</p>
                    <MenuOpenIcon className="nav__burger__icon" />
                </div>
                :
                <div className="nav__burger" onClick={() => setnavClick(!navClick)}>
                    <p>Close</p>
                    <CloseIcon className="nav__burger__icon" />
                </div>
            }
            <div className={navClick ? `nav` : `nav__close`}>
                <Navbar setnavClick={setnavClick} />
            </div>
            <div id="myportfolio">
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal__close" onClick={() => setIsOpen(false)}>
                        <CloseIcon />
                    </div>
                    <div className="service1__modal">
                        <div className="service1__topic">
                            ℕ𝕆 𝕎𝔼𝔹𝕊𝕀𝕋𝔼 𝕀ℕ 𝕊𝕀𝔾ℍ𝕋
                        </div>
                        <a href="#contact" className="lets__do__this" onClick={() => setIsOpen(false)}>LET'S DO THIS!</a>
                        <div className="service1__modal__top">
                            <div className="left__modal">
                                <div>
                                    FASCINATING THINGS I OFFER YOU
                                </div>
                                <p>
                                    01&nbsp;&nbsp;Understand Your Goals
                                </p>
                                <p>
                                    02&nbsp;&nbsp;Discuss about Implementation
                                </p>
                                <p>
                                    03&nbsp;&nbsp;A glorious online presence a.k.a. website
                                </p>
                            </div>
                            <div className="right__modal">
                                <img src="phone.jpg" />
                            </div>
                        </div>
                        <div>
                            <p className="lets__do__this__desc">Wanna put your business out there?</p>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={modalIsOpen2}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal__close" onClick={() => setIsOpen2(false)}>
                        <CloseIcon />
                    </div>
                    <div className="service1__modal">
                        <div className="service1__topic">
                            𝔸𝕃𝕃 𝔹𝔼𝔾𝕀ℕ𝕊 𝔸𝕊 𝔸ℕ 𝕀𝔻𝔼𝔸
                        </div>
                        <a href="#contact" className="lets__do__this" onClick={() => setIsOpen2(false)}>LET'S DO THIS!</a>
                        <div className="service1__modal__top">
                            <div className="left__modal">
                                <div>
                                    AWESOME THINGS I CAN DO
                                </div>
                                <p>
                                    01&nbsp;&nbsp;Define your goals and target audience
                                </p>
                                <p>
                                    02&nbsp;&nbsp;Start working on transforming your idea into a final product
                                </p>
                                <p>
                                    03&nbsp;&nbsp;Tests and Measure results and success
                                </p>
                            </div>
                            <div className="right__modal">
                                <img src="bulb.jpg" />
                            </div>
                        </div>
                        <div>
                            <p className="lets__do__this__desc">Ready to turn your idea into reality?</p>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={modalIsOpen3}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal__close" onClick={() => setIsOpen3(false)}>
                        <CloseIcon />
                    </div>
                    <div className="service1__modal">
                        <div className="service1__topic">
                            ℕ𝔼𝔼𝔻 𝕄𝕆ℝ𝔼 𝔽ℝ𝔼𝔼 𝕋𝕀𝕄𝔼
                        </div>
                        <a href="#contact" className="lets__do__this" onClick={() => setIsOpen3(false)}>LET'S DO THIS!</a>
                        <div className="service1__modal__top">
                            <div className="left__modal">
                                <div>
                                    AWESOME THINGS I CAN DO
                                </div>
                                <p>
                                    01&nbsp;&nbsp;Understand all of the regular tasks in your business
                                </p>
                                <p>
                                    02&nbsp;&nbsp;Automate Automatise Automatize
                                </p>
                                <p>
                                    03&nbsp;&nbsp;With the limited time focus on ways to grow your business
                                </p>
                            </div>
                            <div className="right__modal">
                                <img src="clock.jpg" />
                            </div>
                        </div>
                        <div>
                            <p className="lets__do__this__desc">Ready to put yourself first?
                            </p>
                        </div>
                    </div>
                </Modal>
                <div className='home' id="home">
                    <div className="my__details">
                        {/* <div className="home__img">
                    <img src="myimg.png" className="outer__shadow" alt="Shyam Sundar Developer" />
                </div> */}
                        <div className="duo">A collaborative individual helping you visualize, craft and automate your ideas as a(an)
                            <Typewriter
                                options={{
                                    skipAddStyles: true,
                                    strings: ["UX Developer", "Backend Architect", "Pythoneer", "Network Engineer", "Android Developer"],
                                    autoStart: true,
                                    delay: 70,
                                    deleteSpeed: 30,
                                    pauseFor: 500,
                                    loop: true,
                                }}
                            />
                        </div>
                        <p className="duo__below">I rack my brain to boost your business growth and automate your company processes to relieve you from stress.</p>
                        <p className="home__name">Shyam Sundar B</p>
                        {/* <p className="desc">Simplicity is prerequisite for reliability.</p>
                <Link to="/about" className="btn-1 outer__shadow hover__in__shadow">
                    More About Me
                </Link> */}
                    </div>
                    <div className="home__gif">
                        <img src="bg_gif.gif" />
                    </div>
                </div>
                {/* <About /> */}
                <div className="services__mobile" id="services__mobile">
                    <div onClick={service1Model} >
                        <img src="phone.jpg" />
                        <div className="service__1__mobile">I DONT HAVE A WEBSITE</div>
                    </div>
                    <div onClick={service2Model}>
                        <img src="bulb.jpg" />
                        <div className="service__1__mobile" >𝕀 𝕆ℕ𝕃𝕐 ℍ𝔸𝕍𝔼 𝔸ℕ 𝕀𝔻𝔼𝔸</div>
                    </div>
                    <div onClick={service3Model}>
                        <img src="clock.jpg" />
                        <div className="service__1__mobile">I NEED MORE FREE TIME</div>
                    </div>
                </div>
                <div className="services" id="services">
                    <img
                        // style={{ left: `${x}px` }}
                        className={service1 ? `service__1__img` : `service__img`} src="phone.jpg" />
                    <img
                        // style={{ left: `${x}px` }}
                        className={service2 ? `service__1__img` : `service__img`} src="bulb.jpg" />
                    <div onClick={service1Model} className="service__1" onMouseEnter={cursorChangeService1} onMouseLeave={cursorChangeService1End}>I DONT HAVE A WEBSITE</div>
                    <img
                        // style={{ left: `${x}px` }}
                        className={service3 ? `service__1__img` : `service__img`} src="clock.jpg" />
                    <div onClick={service2Model} className="service__2" onMouseEnter={cursorChangeService2} onMouseLeave={cursorChangeService2End}>𝕀 𝕆ℕ𝕃𝕐 ℍ𝔸𝕍𝔼 𝔸ℕ 𝕀𝔻𝔼𝔸</div>
                    <div onClick={service3Model} className="service__3" onMouseEnter={cursorChangeService3} onMouseLeave={cursorChangeService3End}>I NEED MORE FREE TIME</div>
                </div>

                <div className='about' id="about">
                    <div className="about__me">About Me</div>
                    <div className='about__img'>
                        <svg className="about__blob" viewBox="0 0 200 187" >
                            <mask id="mask0" mask-type="alpha">
                                <path d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 165.547 
                            130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 129.362C2.45775 
                            97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 -0.149132 97.9666 
                            0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z"/>
                            </mask>
                            <g mask="url(#mask0)">
                                <path d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 
                        165.547 130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 
                        129.362C2.45775 97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 
                        -0.149132 97.9666 0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z"/>
                                <image className="about__blob__image" xlinkHref="shyam-sundar-b.png" />
                            </g>
                        </svg>
                        <p className="about__desc">Hey there!! This is Shyam Sundar a professional developer, efficient programmer and data science enthusiast with an intense desire to learn and achieve. I never cease my process of learning, and often spend my time hunting down information on futuristic technology. I fell in deep love with knowledge, curiosity and perfection and they never fail to amaze me.I was born in Puducherry and was brought up in Thirumarugal, Nagapattinam. I did my secondary education at ONGC Public School till tenth and secured a 10 GPA, which intrigued me towards JEE and eventually made me join FIITJEE. Even though I was not successful in clearing JEE Advanced, this helped me establish a solid base. IIIT Kanchipuram and SASTRA are my final choices to pursue my undergraduate degree and I chose SASTRA. Joining engineering made me think "the engineer way" and, moreover, drove me towards exploring the Arduino IDE . And bang, the pandemic happened, pushing me to the ultimate boredom, which made me take a productive decision to set foot in App Development. Android Development in Java was extremely satisfying and later this gave me the motivation to pursue Web Development(MERN). My friends and I started working on projects and by working as a team in different places, we expertise in version control GIT, which helped in doing projects without any difficulties. And finally, I'm a Freelance developer who is eager to collaborate with you.</p>
                    </div>
                </div>

                {/* <Skills /> */}
                <div className="skills" id="skills">
                    <div className="skills__title">Skills</div>
                    <div className="skills__page">
                        <div id="tag">
                        </div>
                        <div className="skills_desc">
                            Having Good knowledge of HTML, CSS, and JS, I can make good use of libraries like jQuery and React JS. I am proficient at backend logic and building RESTful backend using Node JS and Mongoose. I also have the ability to build fully responsive web apps in the MERN stack.
                            Furthermore, I have a good knowledge of Kotlin through which I can build exceptional android apps.
                        </div>
                    </div>
                </div>
                <div id="work">
                    <Portfolio />
                </div>
                {/* <Contact /> */}
                <div className='contact' id="contact" >
                    <ToastContainer
                        position="bottom-left"
                    />
                    <div className="contact__full">
                        {/* <div className="contact__div">
                            <form onSubmit={handleClick}>
                                <div className="contact__logo"></div>
                                <div className="contact__fields">
                                    <div className="contact__email__subject">
                                        <div className="contact__email">
                                            <input onChange={(e) => setemail(e.target.value)} value={email} className="email__input" type="email" readOnly={readOnly} placeholder="Email" required />
                                        </div>
                                        <div className="contact__subject">
                                            <input onChange={(e) => setsubject(e.target.value)} value={subject} className="subject__input" type="text" readOnly={readOnly} placeholder="Subject" />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="contact__email__content">
                                            <textarea onChange={(e) => setmessage(e.target.value)} value={message} rows="3" className="email__content__input" type="text" readOnly={readOnly} placeholder="Message" required />
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="send__button">Send</button>
                            </form>
                        </div> */}
                        <div className="contact__left">
                            <div className='contact__leftHeader'>
                                <h1 className='contact__header'>Contact Information</h1>
                                <div className='contact__text'>
                                    Please do not hesitate to get in touch with me if you have any questions. You can send me an email using the form on the side, or use the social media links below to connect with me...
                                </div>
                                <div className="contact__mailid">
                                    <MailIcon fontSize="large" />
                                    <p>shyamsundar1952001@gmail.com</p>
                                </div>
                                <div className="contact__loaction">
                                    <RoomIcon fontSize="large" />
                                    <p>Karaikal, India</p>
                                </div>
                            </div>
                            <div className="contact__social__icons">
                                <a className="resume__contactpage" href="https://drive.google.com/file/d/1EQP0G5cvHXBTU1Y2FgPDASavWAWYKb2T/view?usp=sharing" target='_blank'>
                                    <DescriptionIcon style={{ fontSize: 20 }} />
                                    <p>Resume</p>
                                </a>
                                <a className="github__contactpage" href="https://github.com/Shyam19sundar" target='_blank'>
                                    <GitHubIcon style={{ fontSize: 20 }} />
                                    <p>Github</p>
                                </a>
                                <a className="linkedin__contactpage" href="https://linkedin.com/in/shyam-sundar-b-6803481a6 " target='_blank'>
                                    <LinkedInIcon style={{ fontSize: 20 }} />
                                    <p>LinkedIn</p>
                                </a>
                                <a className="linkedin__contactpage" href="https://instagram.com/shyam._.sundar?utm_medium=copy_link" target='_blank'>
                                    <InstagramIcon className="insta__contactpage" style={{ fontSize: 20 }} />
                                    <p>Instagram</p>
                                </a>
                            </div>
                        </div>
                        <form className="contact__form__content" onSubmit={sendEmail}>
                            <div className="input__fields">
                                <div>Name</div>
                                <input onChange={(e) => setname(e.target.value)} value={name} type="text" readOnly={readOnly} required name='from_name' />
                            </div>
                            <div className="input__fields">
                                <div>Email</div>
                                <input onChange={(e) => setemail(e.target.value)} value={email} type="email" readOnly={readOnly} required name='from_email' />
                            </div>
                            <div className="input__fields">
                                <div>Subject</div>
                                <input onChange={(e) => setsubject(e.target.value)} value={subject} type="text" readOnly={readOnly} name='subject' />
                            </div>
                            <div className="input__fields">
                                <div>Message</div>
                                <textarea onChange={(e) => setmessage(e.target.value)} value={message} rows="2" type="text" readOnly={readOnly} required name='message' />
                            </div>
                            <button type="submit" className="send__button">Send</button>
                        </form>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Home
